module.exports = __webpack_public_path__ + "img/Cuomo-LaGuardia-Airport-Delta-7-1024x576.575a9f16.png";